/* global $:false */
(function() {
  'use strict';

  angular
    .module('admin.campaigns.promo.codes.edit', [
    ])
    .controller('PromoCodeEditCtrl', PromoCodeEditCtrl);

  /** @ngInject */
  function PromoCodeEditCtrl($scope, $state, $stateParams, $timeout, PromoCodesService) {
    var vm = this;
    vm.model = {};
    vm.id = parseInt($stateParams.id);
    vm.parentId = parseInt($stateParams.parentId);
    vm.promoId = parseInt($stateParams.promoId);

    if (vm.id !== 0) {
      PromoCodesService.get(vm.parentId, vm.id).then(function(result){
        vm.model = result.results;
      });
    }

    vm.save = function(){
      var model = angular.copy(vm.model);
      if (model.code === undefined) {
        swal('Required code', '', 'error');
        return;
      }

      if (model.id !== undefined && model.id !== '' && model.id !== 0) {
        PromoCodesService.update(vm.promoId, model.id, {code: model.code}).then(function(){
          $timeout(function(){
            $state.go('admin.promo_campaigns.promo.codes', {parentId: vm.parentId, promoId: vm.promoId});
          }, 500);
        }, function(){
          $timeout(function(){
            swal('That code is already associated with this promo', '', 'error');
          }, 250);
        });
      } else {
        PromoCodesService.save(vm.promoId, model).then(function(){
          $timeout(function(){
            $state.go('admin.promo_campaigns.promo.codes', {parentId: vm.parentId, promoId: vm.promoId});
          }, 500);
        }, function(){
          $timeout(function(){
            swal('That code is already associated with this promo', '', 'error');
          }, 250);
        });
      }
    };

    vm.cancel = function() {
      $state.go('admin.promo_campaigns.promo.codes', {parentId: vm.parentId, promoId: vm.promoId});
    };
  }

})();
